import SplitText from '@/components/SplitText'
import Swipe from '../../pure/Swipe'

export default
{
    name: 'testimonials',

    components:
    {
        SplitText
    },

    data()
    {
        return {
            current: 0,
            isDescending: false,
            updatePos: false,
            count: 0
        }
    },

    watch:
    {
        current(current, last)
        {
            const isDescending = last > current

            if (isDescending !== this.isDescending)
            {
                this.updatePos = true
                requestAnimationFrame(() => this.updatePos = false)
            }

            this.isDescending = isDescending
        }
    },

    computed:
    {
        prev()
        {
            return Math.max(this.current - 1, 0)
        },

        next()
        {
            return Math.min(this.current + 1, this.count - 1)
        }
    },

    mounted()
    {
        this.count = this.$refs.logos.querySelectorAll('.button').length
        this.swipe = new Swipe(document.body, this.onSwipe, 10)
    },

    destroyed()
    {
        this.swipe.disable()
    },

    methods:
    {
        onSwipe(data, event)
        {
            if (data === 'left' && this.current > 0)
            {
                event.preventDefault()
                this.current--
            }
            else if (data === 'right' && this.current < this.count - 1)
            {
                event.preventDefault()
                this.current++
            }
        },

        setCurrent(current)
        {
            this.current = current
        }
    }
}
